<template>
  <div :class="[backgroundImage ? 'bg-gray-50' : 'bg-white', 'border-b border-gray-200']" :style="backgroundStyle">
    <slot name="top" />

    <div class="px-6 pt-3.5" :class="{ 'pb-3.5': !$slots.bottom }">
      <!-- Breadcrumb -->
      <nav v-if="breadcrumbs.length" class="flex items-center gap-1.5 text-gray-500 mb-1.5" style="font-size: 11px;">
        <template v-for="(crumb, index) in breadcrumbs" :key="index">
          <router-link
            v-if="crumb.to"
            :to="crumb.to"
            class="hover:text-gray-700 transition-colors"
          >
            {{ crumb.label }}
          </router-link>
          <span v-else>{{ crumb.label }}</span>
          <span class="text-gray-300">/</span>
        </template>
        <span :class="['text-gray-700', titleClass]">{{ title }}</span>
      </nav>

      <!-- Title Row -->
      <div class="flex items-start gap-4">
        <div class="flex-1 min-w-0">
          <span class="inline-flex items-center gap-2 title-row">
            <component :is="headingTag" :class="[headingClass, titleClass]" :style="headingStyle">{{ title }}</component>
            <slot name="title-suffix" />
          </span>
          <p v-if="subtitle" class="text-gray-500 mt-1" style="font-size: 13px;">{{ subtitle }}</p>
        </div>
        <div class="flex items-center gap-2">
          <slot name="actions" />
        </div>
      </div>

      <div v-if="$slots.default" class="mt-3 empty:mt-0">
        <slot />
      </div>
    </div>

    <slot name="bottom" />
  </div>
</template>

<script>
import spiralDots from '@/assets/spiral_dots.svg';

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    },
    headingLevel: {
      type: Number,
      default: 1,
      validator: (v) => [1, 2, 3].includes(v)
    },
    breadcrumbs: {
      type: Array,
      default: () => []
      // Each item: { label: string, to?: string }
    },
    backgroundImage: {
      type: Boolean,
      default: false
    },
    titleClass: {
      type: String,
      default: null
    },
  },
  computed: {
    headingTag() {
      return `h${this.headingLevel}`;
    },
    headingClass() {
      return 'font-semibold text-gray-900';
    },
    headingStyle() {
      const sizes = { 1: 19, 2: 17, 3: 15 };
      return { fontSize: `${sizes[this.headingLevel]}px`, letterSpacing: '-0.3px' };
    },
    backgroundStyle() {
      if (!this.backgroundImage) return {};
      return {
        backgroundImage: `url(${spiralDots})`,
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: '-350px',
        backgroundPositionY: '37%',
        backgroundSize: '800px auto',
      };
    }
  }
};
</script>
